// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__RpdZP","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__14Yd3"};